// Browser-neutral geometry for workspace controls. Visual roles (primary,
// tonal, ghost, segmented, navigation) remain with the component that extends
// this base. A control's padding is always INSIDE its declared footprint.
export const AppControl = {
  tag: 'button',
  type: 'button',
  compact: false,
  dataControlSize: (el) => (el.compact ? 'compact' : 'regular'),
  '&[data-control-size]': {
    boxSizing: 'border-box',
    appearance: 'none',
    fontFamily: 'inherit',
    lineHeight: '1.25',
    touchAction: 'manipulation',
    flexShrink: '0'
  },
  '&[data-control-size="regular"]': {
    minHeight: 'controlH',
    minWidth: 'controlH'
  },
  '&[data-control-size="compact"]': {
    minHeight: 'controlHCompact',
    minWidth: 'controlHCompact',
    '@coarse': { minHeight: 'controlH', minWidth: 'controlH' }
  },
  ':focus-visible': { shadow: 'focusRingInset' }
}
